import React from 'react';
export const useNodeMeasurer = ({ minHeight = 0, height } = {}) => {
    const [dimensions, setDimensions] = React.useState({ width: 0, height: height !== null && height !== void 0 ? height : minHeight });
    const onLayout = (event) => {
        const { layout } = event.nativeEvent;
        setDimensions({
            width: layout.width,
            height: height !== null && height !== void 0 ? height : Math.max(minHeight, layout.height)
        });
    };
    return { dimensions, onLayout };
};
//# sourceMappingURL=useNodeMeasurer.js.map